'use client'

import { useState } from 'react'
import type { TabType } from '../rich-text/types'
import classes from './Tabs.module.css'
import { TabContent } from './TabContent'
// import { TabContent } from './TabContent'

interface TabsProps {
  tabs: Array<TabType>
}

export const Tabs = ({ tabs }: TabsProps) => {
  const [activeTab, setActiveTab] = useState(0)

  if (!tabs || tabs.length === 0) {
    return null
  }

  return (
    <div className={classes.tabs}>
      <div role="tablist" className={classes.tabsList}>
        {tabs.map((tab, index) => (
          <button
            key={`tab-${tab.title}`}
            role="tab"
            aria-selected={activeTab === index}
            aria-controls={`panel-${index}`}
            id={`tab-${index}`}
            className={classes.tab}
            onClick={() => setActiveTab(index)}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className={classes.tabsContent}>
        {tabs.map((tab, index) => (
          <div key={`panel-${tab.title}`}>
            <TabContent key={`panel-${tab.title}`} content={tab.content} index={index} activeTab={activeTab} />
          </div>
        ))}
      </div>
    </div>
  )
}
